module.exports = __webpack_public_path__ + "683d22944c789617.svg";